module.exports = __webpack_public_path__ + "img/nj.8c2d849d.svg";